import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createAdmin, editAdmin, getRoleList, 
searchAdminList, getAdminList, deleteAdmin } from '../../actions/permissionsAction'
import { Translate } from '../../../language';
import { UseComponentVisible } from '../../../containers/UseComponentVisible'
import { UseComponentVisible2 } from '../../../containers/UseComponentVisible2'
import { ReactComponent as CloseIcon } from '../../../img/ic_cerrar.svg';
import Calendar from 'react-calendar';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const AdminUsers = ({ history, createAdmin, getRoleList, getAdminList, editAdmin, isLoadinglistRoleAdmin, searchAdminList, isLoadingListAdmin, listAdmin, listRoleAdmin, listTypeOfadminUsers, seeListChallengeadminUser, deleteAdmin, isLoadingListTypeOfadminUsers }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getRoleList()
            getAdminList()
        })
        
    },[])

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameUserAdmin, setNameAdmin] = useState('')
    const [emailAdmin, setEmailAdmin] = useState('')
    const [password, setPassword] = useState('')
    const [phoneAdmin, setPhoneAdmin] = useState('')
    const [date, setDate] = useState(new Date())
    const [dateView, setDateView] = useState('')
    const [isVisibleCalendar, setIsVisibleCalendar] = useState(false)
    const [description, setDescription] = useState('')
    const [ubicationAdmin, setUbicationAdmin] = useState('')
    const [gender, setGender] = useState('')
    const [urlPicture, setUrlPicture] = useState('')
    const [listRoles, setListRoles] = useState('')
    const [nameChallenge, setNameChallenge] = useState('')
    const [idChallenge, setIdChallenge] = useState('')
    const [idsRoles, setIdsRoles] = useState('')
    const [dataFile, setDataFile] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
    const onChange = dateTime => {
        const saveDate = new Date(dateTime)
        setDateView(saveDate.getDate() + '/' + (saveDate.getMonth() + 1) + '/' + saveDate.getFullYear())
        setDate(dateTime)
        setIsVisibleCalendar(false)
        console.log()
    }
    const handleSelectGender = (e) => {
        var { value } = e.target;
        setGender(value)
    }

    useEffect(() => {
        var dateObj = new Date(date)
        var month = dateObj.getUTCMonth();
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var newDate = day + "/" + month + "/" + year
        setDateView(newDate)
    }, [date])

    useEffect(() => {
        if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
            setValidate(true)
        }
    }, [idsRoles])
    useEffect(() => {
        if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
            setValidate(true)
        }
    }, [gender])

    const onFileChange = (event) => {
        var filesTarget = event.target.files[0]
        filesTarget.url = URL.createObjectURL(event.target.files[0])
        setUrlPicture(URL.createObjectURL(event.target.files[0]))
        setDataFile(filesTarget)
        console.log()

    }

    const isEmpty = (e) => {
        if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }

    const deleteChallenges = (id) => {

        setListRoles(prevState => {
            var prevStateDelete = prevState
            delete prevStateDelete[id]
            return ({ ...prevStateDelete })
        })
    }

    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);

    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);


    const saveadminUser = () => {
        const formData = new FormData();
        formData.append('files', dataFile)
        formData.append('name', nameUserAdmin.trim())
        formData.append('email', emailAdmin)
        formData.append('phone', phoneAdmin)
        formData.append('ubication', ubicationAdmin)
        formData.append('gender', gender)
        formData.append('description', description)
        formData.append('password', password)
        formData.append('birthDate', date)
        var rolesListData = Object.keys(listRoles)
        console.log()
        if (rolesListData.length !== 0) {
            for (var i = 0; i < rolesListData.length; i++) {
                formData.append('adminRoleID', rolesListData[i])
            }
        }
        createAdmin(formData, history)

    }

    const updateadminUser = () => {
        const formData = new FormData();
        if (dataFile !== '') {
            formData.append('files', dataFile)
        }
        formData.append('name', nameUserAdmin.trim())
        formData.append('email', emailAdmin)
        formData.append('phone', phoneAdmin)
        formData.append('ubication', ubicationAdmin)
        formData.append('gender', gender)
        formData.append('description', description)
        formData.append('adminUserId', idEdit)
        var rolesListData = Object.keys(listRoles)
        if (rolesListData.length !== 0) {
            for (var i = 0; i < rolesListData.length; i++) {
                formData.append('adminRoleID', rolesListData[i])
            }
        }
        editAdmin(formData, indexEdit, history)

    }

    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin new-admin-user-container">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} usuario`}</div>
                <div className="container-inputs-new-mark new-admin-inputs-container">
                    <div className="column centerContent centerItems">
                        <label className="picture-register-mark">
                            <input type="file" onChange={(event) => { 
                                 if(event.target.files[0] && event.target.files[0].type.includes('image')){
                                onFileChange(event) }}} accept="image/*" />
                            {urlPicture && <img className="img-100-center" src={urlPicture}></img>}
                        </label>
                    </div>
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='nameUserAdmin'
                        className='inputs-admin'
                        value={nameUserAdmin}
                        onChange={(e) => {
                            setNameAdmin(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.nameUserAdmin}</div>
                    <div className="text-input-admin">
                        {'Correo:'}
                    </div>
                    <input
                        name='emailAdmin'
                        className='inputs-admin'
                        type='email'
                        value={emailAdmin}
                        onChange={(e) => {
                            setEmailAdmin(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.emailAdmin}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        name='description'
                        className='inputs-admin'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>
                    <div className="text-input-admin">
                        {'Contraseña:'}
                    </div>
                    {!isEdit && <input
                        name='password'
                        className='inputs-admin'
                        value={password}
                        type='password'
                        onChange={(e) => {
                            setPassword(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />}
                    {!isEdit && <div className="text-error text-error-admin">{error.password}</div>}
                    <div className="text-input-admin">
                        {'Telefono:'}
                    </div>
                    <input
                        name='phoneAdmin'
                        className='inputs-admin'
                        value={phoneAdmin}
                        type='number'
                        min='1'
                        onChange={(e) => {
                            setPhoneAdmin(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.phoneAdmin}</div>
                    <div className="text-input-admin">
                        {'Ubicacion:'}
                    </div>
                    <input
                        name='ubicationAdmin'
                        className='inputs-admin'
                        value={ubicationAdmin}
                        type='text'
                        onChange={(e) => {
                            setUbicationAdmin(e.target.value.trimStart())
                            if (listRoles !== '' && nameUserAdmin !== '' && emailAdmin !== '' && phoneAdmin !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.ubicationAdmin}</div>
                    <div className="text-input-admin">
                        {'Sexo:'}
                    </div>
                    <select className='inputs-admin' name="gender" id="gender" placeholder={Translate('gender', 'es')} onChange={(e) => { handleSelectGender(e) }}>
                        <option value="" selected disabled hidden>Seleccion</option>
                        <option value={Translate('female', 'es')}>{Translate('female', 'es')}</option>
                        <option value={Translate('male', 'es')}>{Translate('male', 'es')}</option>
                        <option value={Translate('other', 'es')}>{Translate('other', 'es')}</option>
                    </select>
                    <div className="text-input-admin">
                        {Translate('birthDate', 'es') + ':'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="birth"
                        type="text"
                        value={dateView}
                        onFocus={() => setIsVisibleCalendar(true)}
                        autoComplete='off'
                    />
                    {isVisibleCalendar ?
                        <div className="row centerItems div-calendar">
                            <Calendar
                                onChange={(dateTime) => onChange(dateTime)}
                                value={date}
                            />
                        </div> :
                        <div></div>
                    }
                    <div className="text-error text-error-admin">{error.birth}</div>
                    <div className="parent-width relative" ref={ref}>
                        <div
                            className="modal-content-button-search-bar"
                            onClick={() =>
                                setIsComponentVisible(true)
                            }
                        >
                            <div>
                                <div className="text-input-admin">
                                    {'Roles:'}
                                </div>
                                <input className="inputs-admin" onChange={(e) => {
                                    console.log()
                                }} type="text" />
                            </div>
                        </div>
                        {isComponentVisible &&
                            <div className='scroll-menu modal-search-bar'>
                                <div className="modal-results-search-bar">
                                    <div>
                                        {isLoadinglistRoleAdmin ? <div></div> :
                                            listRoleAdmin.map((role) => (
                                                !listRoles[role._id] &&
                                                <div
                                                    className="column centerItems"
                                                    key={role._id}
                                                    onClick={() => {
                                                        setIsComponentVisible2(false)
                                                        setListRoles(prevState => { return { ...prevState, [role._id]: role } })
                                                        setIdsRoles(prevState => { return { ...prevState, [role._id]: role._id } })
                                                    }} >
                                                    {role.name}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className='wrapper-2'>
                        {Object.values(listRoles).length > 0 ?
                            Object.values(listRoles).map(role =>
                                <div className="relative">
                                    <div style={{ width: '80%' }}>
                                        <div className="textBlack" name={role.name} />{role.name} </div>
                                    <div onClick={() =>
                                        deleteChallenges(role._id)
                                    } className="delete-invite-listRoles-icon ml-2">
                                        <CloseIcon className="cls-1" height="18" width="18" />
                                    </div>
                                </div>
                            )
                            :
                            <div>

                            </div>}
                    </div>


                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameAdmin('')
                                setDataFile('')
                                setUrlPicture('')
                                setListRoles('')
                                setDescription('')
                                setPassword('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    updateadminUser()
                                    setListRoles('')
                                    setNameAdmin('')
                                    setDataFile('')
                                    setUrlPicture('')
                                    setDescription('')
                                    setPassword('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { saveadminUser() }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Administradores existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListAdmin ? <div>Cargando...</div> :
                        listAdmin && listAdmin.map((adminUser, index) => (
                            <div key={adminUser._id} className="card-admin">
                                <img className="img-card-admin" src={adminUser.profilePicture && adminUser.profilePicture.url}></img>
                                <div className="tittle-card-admin">{adminUser.name}</div>
                                <div className="text-content-card">{adminUser.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameAdmin(adminUser.name)
                                        setListRoles({})
                                        adminUser.adminRoleID && adminUser.adminRoleID.map((role, index) => (setListRoles(prevState => { return { ...prevState, [role._id]: role } })))
                                        setDescription(adminUser.description)
                                        setPhoneAdmin(adminUser.phone)
                                        setGender(adminUser.gender)
                                        setUbicationAdmin(adminUser.ubication)
                                        setDate(adminUser.birthDate)
                                        setEmailAdmin(adminUser.email)
                                        setPassword(adminUser.password)
                                        setUrlPicture(adminUser.profilePicture && adminUser.profilePicture.url)
                                        setIdEdit(adminUser._id)
                                        setEnable(adminUser.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteAdmin(adminUser._id, index) }}>Eliminar</div>

                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadinglistRoleAdmin: state.permissionsAdmin.isLoadinglistRoleAdmin,
        listRoleAdmin: state.permissionsAdmin.listRoleAdmin,
        listAdmin: state.permissionsAdmin.listAdmin,
        isLoadingListAdmin: state.permissionsAdmin.isLoadingListAdmin,
    }
}


export default connect(mapStateToProps, { createAdmin, editAdmin, searchAdminList, getAdminList, getRoleList, deleteAdmin })(AdminUsers)